export default __webpack_public_path__ + "static/media/shield.7f590e16.svg";